import React from "react";
import { Typography, Grid } from "@mui/material";
import Dialog from "../Dialog/Dialog";
import ViewUtils from "../../../utils/viewUtility";
import { Lottie } from "@alfonmga/react-lottie-light-ts";
import { withStyles } from '@mui/styles';
import loaderAnimation from "../../animations/loader.json";
const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: loaderAnimation,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};
const styles = (theme) => ({
  popUpMargin: {
    "& .MuiDialogContent-root": {
      padding: "0 !important",
    },
    [theme.breakpoints.down('md')]: {
      margin: "0.5rem",
      "&  > :nth-child(2)": {
        //margin:'0.5rem',
        //width: '91%'
      },
    },
  },
  loadingPopup: {
    borderRadius: "0.5rem !important",
    width:"unset !important",
  },
  progress: {
    //margin: theme.spacing.unit * 4,
    margin: theme.spacing(4),
  },
  container: {
    height: "180px",
    width: "180px",
    justifyContent: "center",
    maxWidth: "100%",
  },
  logoWrapper:{
      position:"relative",
      width:"100%",
      height:"132px",
  },
  title:{
      fontSize:"14px",
      position:"relative",
      top:"-22px"
  }
});

export const loader = (props) => {
  const { classes, showLoader } = props;
  return (
    <Dialog
      open={showLoader}
      blocking={props.blocking}
      noTitle
      actionBtn={false}
      contentClassName={classes.dialogRoot}
      PaperProps={{ className: classes.loadingPopup }}
      className={classes.popUpMargin}>
      <Grid container alignItems="center" className={classes.container}>
        <Grid item className={classes.logoWrapper}>
          <Lottie
            config={defaultOptions}
            width={"73%"}
          />
          
        </Grid>
        <Typography variant="h6" component="h1" align="center" className={classes.title}>
                        {(props.loaderText) ? props.loaderText : ViewUtils.PLEASE_WAIT}
                    </Typography>
      </Grid>
    </Dialog>
  );
};
export default withStyles(styles)(loader);
